import { GrayImage2 } from './../share/image';
import { EntityDragEvent } from './../../ng3/controls/mouse/mouse-entity.service';
import { Vector2 } from 'three';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, noop } from 'rxjs';
import { map } from 'rxjs/operators';
import { Plane2Model } from '../../ng3/model';
import { BoundingBox2FromCenterSize } from '../../ng3/share/boundingbox2';
import { Ng3MosueWheelEvent } from '../../ng3/controls/mouse/mouse-canvas.service';
import { dummyGrayImage } from '../../image-store/http-image-loader/image.debug.repository';

@Component({
  selector: 'app-image2d-gray',
  templateUrl: './image2d-gray.component.html',
  styleUrls: ['./image2d-gray.component.css']
})
export class Image2dGrayComponent implements OnInit {
  model$: Observable<Plane2Model>;
  private imageSubject = new BehaviorSubject<GrayImage2>(
    // new GrayImage2(
    //   new Vector2(0, 0),
    //   new Vector2(78, 58),
    //   new Vector2(1, 1),
    //   new Float32Array([255]),
    // ),
    dummyGrayImage(new Vector2(60, 60), new Vector2(60, 120))
  );
  image$ = this.imageSubject.asObservable();
  @Input()
  get image(): GrayImage2 {
    return this.imageSubject.value;
  }
  set image(s: GrayImage2) {
    if (s === undefined || s === null) {
      throw Error('Can not set Display2DProperty with null');
    }
    this.imageSubject.next(s);
  }
  @Input() z = 0;

  // @Output() scroll = new EventEmitter<number>();
  @Output() scroll = new EventEmitter<Ng3MosueWheelEvent>();
  @Output() drag = new EventEmitter<EntityDragEvent>();
  constructor() {
    this.model$ = this.image$.pipe(
      map((image) => {
        return new Plane2Model(
          new BoundingBox2FromCenterSize(
            image.meta.center,
            image.meta.size,
          ),
          10,
          {
            r: new Uint8Array(image.data),
            g: new Uint8Array(image.data),
            b: new Uint8Array(image.data),
            shape: new Vector2(
              image.meta.shape.x,
              image.meta.shape.y,
            ),
          },
        );
      }),
    );
    this.model$.subscribe(noop, (e) => console.error(e));
  }
  onWheelEvent(e: Ng3MosueWheelEvent) {
    this.scroll.emit(e);
  }
  onDragEvent(d: EntityDragEvent) {
    this.drag.emit(d);
  }
  ngOnInit() {}
}
